import PButton from "@/components/PButton.tsx";
import {ProductPrice} from "@/types";
import {Table, TableBody, TableCell, TableColumn, TableHeader, TableRow} from "@heroui/table";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {createFileRoute} from '@tanstack/react-router'
import React from "react";
import Content from "../../../components/Content.tsx";
import Header from "../../../Header.tsx";
import services from "../../../services";
import queryKeys from "../../../utilities/queryKeys.ts";

export const Route = createFileRoute('/_app/master/products')({
    component: RouteComponent,
})

function RouteComponent() {
    const queryClient = useQueryClient();
    const productsQuery = useQuery<any[]>({
        queryKey: queryKeys.products(),
        queryFn:  services.admin.products,
    })

    const createPriceMut = useMutation({
        mutationFn: async (price: ProductPrice) => services.admin.createPriceOnStripe(price.uid),
        onSuccess:  () => {
            queryClient.invalidateQueries({queryKey: queryKeys.products()})
        }
    })

    const products = (productsQuery.data?.[0] ? productsQuery.data : []);

    return (
        <div>
            <Header />
            <Content>
                <Table aria-label="Transactions list" classNames={{wrapper: "p-1", th: "px-1 text-center", td: "px-1 py-1 text-center"}}
                       isVirtualized={true}
                       isStriped={true}
                       isHeaderSticky={true}>
                    <TableHeader>
                        <TableColumn className={"text-left"}>Created</TableColumn>
                        <TableColumn className={"text-left"}>Name</TableColumn>
                        <TableColumn className={"text-left"}>Prices</TableColumn>
                    </TableHeader>
                    <TableBody>
                        {products.map((product: any) => (
                            <TableRow key={product.uid}>
                                <TableCell className="text-left pl-2">
                                    {product.created_at.replace(/\..*/, '')}<br />
                                </TableCell>
                                <TableCell className="text-left pl-2">
                                    <div>
                                        {product.name || 'NONAME'}<br />
                                    </div>
                                </TableCell>
                                <TableCell className="text-left pl-2 pb-1">
                                    {(product.prices || []).map((price: ProductPrice) => (<>
                                        {price.currency_code} {price.price_cents / 100} {price.billing_period}
                                        {' '}
                                        <PButton size={"sm"} isDisabled={!!price.stripe_price_id}
                                                 onPress={() => createPriceMut.mutate(price)}
                                                 isLoading={createPriceMut.isPending}
                                        >Create on Stripe</PButton>
                                        <br />
                                    </>))}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                {productsQuery.data?.length === 0 && (
                    <div>No products found.</div>
                )}

            </Content>
        </div>
    )
}
